import React, { useMemo } from 'react'
import { OFFER_TYPE_ALWAYS_ON } from 'constants/offer'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Group from 'components/utils/Group'

interface Props {
  finePrint: string;
  offer: App.Offer;
}

function FinePrint(props: Props) {
  const { finePrint, offer } = props

  const cancellationPolicies = useMemo(() => offer.packages.reduce<Utils.PartialRecord<App.CancellationPolicyType, Array<string>>>((acc, pkg) => {
    const cancellationPolicy = pkg.roomRate?.cancellationPolicy

    if (cancellationPolicy?.type) {
      acc[cancellationPolicy?.type] = cancellationPolicy.policyDetail
    }

    return acc
  }, {}), [offer.packages])

  return (
    <Group direction="vertical" gap={20}>
      {!!offer.property?.taxesAndFeesContent &&
        <Group direction="vertical" gap={12}>
          <BodyText variant="medium" weight="bold">
            Taxes & fees:
          </BodyText>
          <MarkdownRender type="compact" fontSize="medium" content={offer.property?.taxesAndFeesContent} />
        </Group>
      }

      {offer.type === OFFER_TYPE_ALWAYS_ON && Object.entries(cancellationPolicies).filter(([_, policy]) => !!policy).map(([policyType, policy], index) => (
        <Group direction="vertical" gap={12} key={policyType}>
          {index === 0 && <BodyText variant="medium" weight="bold">Cancellation Policy</BodyText>}
          {policy.map((item, index) => (
            <BodyText variant="medium" key={index}>{item}</BodyText>
          ))}
        </Group>
      ))}

      {('dynamic' in cancellationPolicies) &&
        <BodyText variant="medium">
          Please note cancellation policies vary depending on the rate selected, please choose your package carefully. See full&nbsp;
          <TextLink weight="regular" to="/booking-policies#lux-premium-collection" target="_blank">
            booking terms and conditions
          </TextLink>
        </BodyText>

      }
      <MarkdownRender type="compact" fontSize="medium" content={finePrint} />
    </Group>
  )
}

export default FinePrint
